export const getTemperatureId = (temp: string): number => {
	switch (temp) {
	case 'CHILLED':
		return 2;
	case 'FROZEN':
		return 3;
	default:
		return 1;
	}
}